<template>
  <div class="limitation">
    <Form
      ref="formValidate"
      :model="formValidate"
      :rules="ruleValidate"
      :label-width="140"
    >
      <Row>
        <FormItem label="领券渠道：" prop="rule" style="width: 50%">
          <Radio :value="true">教务老师派券</Radio>
        </FormItem>
      </Row>
      <Row>
        <FormItem label="可派学生范围：" prop="rule">
          <div class="flex align-items">
            <RadioGroup v-model="formValidate.grantType">
              <Radio label="0">全部学生</Radio>
              <Radio label="1">指定学生</Radio>
            </RadioGroup>

            <div class="student-name">
              <p>{{ studentStr }}</p>
              <Button
                class="btn"
                type="primary"
                size="small"
                @click="handleOpenStu"
                :disabled="formValidate.grantType == 0"
                >选择</Button
              >
            </div>
          </div>
        </FormItem>
      </Row>
      <Row>
        <FormItem label="限领次数：" prop="rule" style="width: 50%">
          <RadioGroup v-model="formValidate.group">
            <Radio label="1">不限</Radio>
            <Radio label="2"
              >每人最多领<InputNumber
                :disabled="formValidate.group == 1"
                :min="1"
                v-model="formValidate.receiveLimit"
                placeholder="请输入"
              ></InputNumber
              >次</Radio
            >
          </RadioGroup>
        </FormItem>
      </Row>
      <Row>
        <FormItem label="使用说明：" prop="rule" style="width: 50%">
          <Input
            v-model="formValidate.couponDesc"
            type="textarea"
            :rows="4"
            placeholder="请输入使用说明"
          />
        </FormItem>
      </Row>
    </Form>
    <ChooseStudent
      ref="chooseStudentRef"
      :school-id="formValidate.schoolId"
      :yearTerms="[formValidate.yearCode, formValidate.termCode]"
      @on-finish="onChooseStudentFinish"
      :yearTermStr="yearTermStr"
    ></ChooseStudent>
  </div>
</template>

<script>
import ChooseStudent from './ChooseStudent.vue'
export default {
  props: {
    details: {
      type: Object,
      default: null
    }
  },
  components: {
    ChooseStudent
  },
  data() {
    const validateRule = (rule, value, callback) => {
      callback();
    };
    return {
      yearTermStr: '',
      formValidate: {
        schoolId: '',
        yearCode: '',
        termCode: '',
        couponDesc: '',
        receiveChannel: 1,
        receiveLimit: null,
        grantType: '1',
        group: '1',
        studentList: []
      },
      ruleValidate: {
        rule: [
          { required: true, validator: validateRule, trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    studentStr() {
      return this.formValidate.studentList.map(item => { return item.userName }).join('、')
    }
  },
  watch: {
    details(newVal) {
      this.fillForm(newVal)
    }
  },
  methods: {
    // 编辑回填
    fillForm(info) {
      let { couponDesc, receiveChannel, receiveLimit, grantType, userList } = info
      this.formValidate.couponDesc = couponDesc
      this.formValidate.receiveChannel = receiveChannel
      this.formValidate.grantType = String(grantType)
      this.formValidate.group = receiveLimit == -1 ? '1' : '2'
      this.formValidate.receiveLimit = receiveLimit == -1 ? null : receiveLimit
      this.formValidate.studentList = grantType == 1 ? userList : []

    },
    checkForm() {
      let { couponDesc, receiveChannel, grantType, receiveLimit, group, studentList } = this.formValidate
      if (!receiveChannel) {
        this.$Message.warning('请选择领券渠道');
        return false
      }
      if (grantType == 1 && studentList.length == 0) {
        this.$Message.warning('请选择指定的学生');
        return false
      }
      if (group == 2 && !receiveLimit) {
        this.$Message.warning('请输入每人最多领取的次数');
        return false
      }
      if (!couponDesc) {
        this.$Message.warning('请输入使用说明');
        return false
      }

      return true
    },
    // 获取参数
    async getParameter() {
      return new Promise(async (resolve, reject) => {
        let { couponDesc, receiveChannel, grantType, receiveLimit, group, studentList } = this.formValidate
        let scopeStuIds = []
        if (grantType == 1) {
          scopeStuIds = studentList.map(item => { return item.userId })
        }
        resolve({
          couponDesc, receiveChannel, grantType, receiveLimit: group == 1 ? -1 : receiveLimit, scopeStuIds
        })
      }
      )
    },
    handleOpenStu() {
      let { schoolId, yearCode, termCode } = this.$parent.getBaseInfoForm().formValidate
      this.formValidate.schoolId = schoolId
      this.formValidate.yearCode = yearCode
      this.formValidate.termCode = termCode
      this.yearTermStr = this.$parent.getBaseInfoForm().yearTermStr
      if (!this.formValidate.schoolId) {
        return this.$Message.error('请先选择学校！');
      }
      if (!this.formValidate.yearCode) {
        return this.$Message.error('请先选择学期！');
      }


      this.$nextTick(() => {
        this.$refs.chooseStudentRef.open(this.formValidate.studentList);
      })

    },
    onChooseStudentFinish(data) {
      this.formValidate.studentList = data
    }
  }
}
</script>

<style lang="scss" scoped>
.limitation {
  margin-bottom: 16px;
}
.student-name {
  position: relative;
  border: 1px solid #eee;
  border-radius: 6px 0 0 6px;
  width: 300px;
  height: 26px;
  line-height: 26px;

  > p {
    color: #ccc;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding-left: 8px;
  }

  .btn {
    position: absolute;
    right: -44px;
    top: 0;
  }
}
</style>